<div class="template">
  <h4 class="text-uppercase vertical-align-middle mt-2 pl-3">{{ filterValue }}</h4>
  <div class="device-info">
    <div class="row">
      <div>
        <h4 class="m-0 mt-1 ml-4 app-color-1 vertical-align-middle">
          <strong>
            <span class="material-icons app-color-dark link-cursor" (click)="hideView()">arrow_back</span>
          </strong>
          &nbsp;
          <strong class="app-color-dark">{{'Device Detail - Calibration History' | translate}}</strong>
        </h4>
      </div>
    </div>
    <div class="row ml-2 mr-3">
      <hr class="col-md-12">
    </div>
    <div class="table-responsive">
      <table class="table table-striped" matSortDisableClear matSort matSortActive="severity" matSortDirection="asc"
        (matSortChange)="sortDevicesByHistory($event)">
        <thead>
          <tr>
            <th scope="col" mat-sort-header="sensor.Name" style="position: relative; left: 3%;">{{'Site / Dept' | translate}}</th>
            <th scope="col" mat-sort-header="calibrationDate">{{'Calibration Date' | translate}}</th>
            <th scope="col" mat-sort-header="calibrationStatus">{{'State' | translate}}</th>
            <th>{{'Certificate Link' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          @if (gridCalibrationHistory && gridCalibrationHistory.data.length > 0) {
            @for (device of $safeNavigationMigration(gridCalibrationHistory?.data) | paginate: { itemsPerPage: itemsPerPage, currentPage: p, totalItems: $safeNavigationMigration(gridCalibrationHistory?.count) }; track trackByIndex($index)) {
              <tr
                >
                <td>
                  <div>
                    <h6 class="details-text">{{ device?.sensorName }}</h6>
                  </div>
                </td>
                <td>
                  <h6 class="details-text">{{ $safeNavigationMigration(device?.calibrationDate) | dateFormat }}</h6>
                </td>
                <td>
                  <h6 class="details-text"
                    [ngClass]="{'pass': $safeNavigationMigration(device?.calibrationStatus), 'fail': !device?.calibrationStatus}">
                    {{ (device?.calibrationStatus ? 'PASS' : 'FAIL') | translate }}
                  </h6>
                </td>
                <td>
                  <a class="certificate-link cursor-pointer"
                    (click)="device?.certificateUrl && viewCertificate($safeNavigationMigration(device?.certificateUrl))">
                    <h6 class="details-text">
                      {{ 'Certificate Link' | translate }}
                    </h6>
                  </a>
                </td>
              </tr>
            }
          }
          @if (!calibrationHistory || calibrationHistory.length === 0) {
            <tr class="no-calib-history">
              <td colspan="3" class="no-data-available with-padding">{{'No Device Calibration History Found' | translate}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  @if (calibrationHistory && calibrationHistory.length > 0) {
    <nav aria-label="Page navigation example"
      class="nav-label">
      <pagination-template #pt="paginationApi" (pageChange)="onPageChange($event)" (pageBoundsCorrection)="p = $event">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="pt.isFirstPage()">
            <a class="page-link" href="javascript:void(0)" (click)="pt.setCurrent(1)">{{'First' | translate}}
            </a>
          </li>
          <li class="page-item" [class.disabled]="pt.isFirstPage()">
            <a class="page-link" href="javascript:void(0)" (click)="!pt.isFirstPage() && pt.previous()"
              aria-label="Previous">
              <span class="material-icons">arrow_back</span>
              <span class="sr-only">{{'Previous' | translate}}</span>
            </a>
          </li>
          @for (page of pt.pages; track trackByIndex($index)) {
            <li class="page-item" [class.current]="pt.getCurrent() === page.value">
              <a class="page-link" href="javascript:void(0)"
                (click)="pt.getCurrent() !== page.value && pt.setCurrent(page.value)">
                {{ page.label }}
              </a>
            </li>
          }
          <li class="page-item" [class.disabled]="pt.isLastPage()">
            <a class="page-link" href="javascript:void(0)" (click)="!pt.isLastPage() && pt.next()" aria-label="Next">
              <span class="material-icons">arrow_forward</span>
              <span class="sr-only">{{'Next' | translate}}</span>
            </a>
          </li>
          <li class="page-item" [class.disabled]="pt.isLastPage()">
            <a class="page-link" href="javascript:void(0)" (click)="pt.setCurrent(pt.getLastPage())">{{'Last' | translate}}
            </a>
          </li>
        </ul>
      </pagination-template>
    </nav>
  }
</div>